import React, {
  ReactElement, ReactNode, useMemo, useState,
} from 'react';
import Context, { PracovnyKrokLegislativnyMaterialContextContent } from './PracovnyKrokLegislativnyMaterialContext';

interface Props {
  children: ReactNode;
}

const PracovnyKrokLegislativnyMaterialContextProvider = ({ children }: Props): ReactElement => {
  const [material, setMaterial] = useState(null);
  const [loadingMaterial, setLoadingMaterial] = useState(false);

  const value: PracovnyKrokLegislativnyMaterialContextContent = useMemo(() => ({
    material,
    setMaterial,
    loadingMaterial,
    setLoadingMaterial,
  }), [material, setMaterial, loadingMaterial, setLoadingMaterial]);

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

export default PracovnyKrokLegislativnyMaterialContextProvider;
